import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type InfoPopupType = 'info' | 'success' | 'warning' | 'danger';

export interface InfoPopupState {
  isVisible: boolean;
  title: string;
  message: string;
  type: InfoPopupType;
  dismissKey?: string;
}

const DEFAULT_STATE: InfoPopupState = {
  isVisible: false,
  title: '',
  message: '',
  type: 'info',
};

@Injectable({ providedIn: 'root' })
export class InfoPopupService {
  private readonly stateSubject = new BehaviorSubject<InfoPopupState>(DEFAULT_STATE);
  public readonly state$ = this.stateSubject.asObservable();

  public show(state: Omit<InfoPopupState, 'isVisible'>): void {
    if (state.dismissKey && this.isDismissed(state.dismissKey)) {
      return;
    }

    this.stateSubject.next({
      ...state,
      isVisible: true,
    });
  }

  public hide(): void {
    const currentState = this.stateSubject.value;
    this.stateSubject.next({
      ...currentState,
      isVisible: false,
    });
  }

  public dismissPermanently(dismissKey: string): void {
    localStorage.setItem(this.buildStorageKey(dismissKey), '1');
    this.hide();
  }

  private isDismissed(dismissKey: string): boolean {
    return localStorage.getItem(this.buildStorageKey(dismissKey)) === '1';
  }

  private buildStorageKey(dismissKey: string): string {
    return `np.infoPopup.dismissed.${dismissKey}`;
  }
}
